<template>
  <div>
    <v-button inline class="qr-code-scan d-flex align-center" @click="scan()">
      <div><span class="icon-qr qr-code-scan__icon text--xxx-large rotate-90 d-inline-block"></span></div>
    </v-button>

    <v-modal no-padding v-model="showBrowserScan" animation="slide-up">
      <template #header>
        {{ $t('components.QrCodeScan.ScanQrCode') }}
      </template>

      <qr-code-scan-browser @decode="onDecode"></qr-code-scan-browser>

      <template #footer>
        <v-button width="full" @click="showBrowserScan = false" color="error">{{ $t('components.Profile.addShop.close') }}</v-button>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core'

import vButton from '@/ui/controls/vButton'
import vModal from '@/ui/modals/vModal'

import QrCodeScanBrowser from '@/components/QrCodeScanBrowser'

import nativeBarcodeScan from '@/mixins/nativeBarcodeScan'
import screen from '@/mixins/screen'

export default {
  name: 'dashboard-add-order',

  mixins: [nativeBarcodeScan, screen],

  data () {
    return {
      showBrowserScan: null,
      hasCamera: true
    }
  },

  components: {
    vButton,
    QrCodeScanBrowser,
    vModal
  },

  methods: {
    async checkHasCamera () {
      if (Capacitor.isNativePlatform()) {
        this.hasCamera = true
        return
      }
      if (!('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices)) {
        this.hasCamera = false
        return
      }

      try {
        const devices = await navigator.mediaDevices.enumerateDevices()
        if (!devices.length) {
          this.hasCamera = false
          return
        }
        devices.forEach(item => {
          if (item.kind === 'videoinput') this.hasCamera = true
        })
      } catch (e) {
        this.hasCamera = false
      }
    },

    async scan () {
      if (Capacitor.isNativePlatform()) {
        const uid = await this.nativeBarcodeScan()
        this.$emit('change', uid)
      } else {
        this.showBrowserScan = true
      }
    },

    onDecode (e) {
      if (e) {
        this.showBrowserScan = false
        this.$emit('change', e)
      }
    }
  },

  mounted () {
    this.checkHasCamera()
  }
}
</script>

<style lang="scss">
.qr-code-scan {
  &__icon {
    color: $color-success;
    font-size: 3rem;
  }
}
</style>
